import Image from '@components/ui/image'
import Container from '@components/ui/layout/Container'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading, Text } from '@components/ui/typography'
import { FadeInChild } from '@components/_home/FadeInChild'
import { urlFor } from '@lib/sanity/url-for'
import React, { FC } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'
import { SectionBottomLine } from '../bottom-line'
import { SectionHeading } from '../section-heading'
import * as styles from './styles'

type BeforeAfterProps = HowItWorksSingleton['fields']['comparing']

export const BeforeAfter: FC<BeforeAfterProps> = ({ comparingTitle, images }) => {
  return (
    <section>
      <SectionHeading title={comparingTitle} />
      <div className={styles.itemContainer}>
        {images.map((item, key) => {
          if (!item.comparisonBeforeImage || !item.comparisonAfterImage || !item.comparisonIcon) {
            return null
          }

          return (
            <FadeInChild key={`${item.comparisonTitle}-${key}`}>
              <Container as="div" className={styles.images}>
                <Image
                  className={styles.beforeImage}
                  placeholderSrc={urlFor(item.comparisonBeforeImage).width(20).url()}
                  sources={[
                    urlFor(item.comparisonBeforeImage).width(620).url(),
                    urlFor(item.comparisonBeforeImage).width(620).url(),
                    urlFor(item.comparisonBeforeImage).width(620).url(),
                    urlFor(item.comparisonBeforeImage).width(1000).url(),
                  ]}
                  ratio={[0.45]}
                  alt=""
                />
                <Image
                  className={styles.afterImage}
                  placeholderSrc={urlFor(item.comparisonAfterImage).width(20).url()}
                  sources={[
                    urlFor(item.comparisonAfterImage).width(620).url(),
                    urlFor(item.comparisonAfterImage).width(620).url(),
                    urlFor(item.comparisonAfterImage).width(620).url(),
                    urlFor(item.comparisonAfterImage).width(1000).url(),
                  ]}
                  ratio={[0.45]}
                  alt=""
                />
              </Container>
              <SmallContainer className={styles.contentContainer}>
                <div className={styles.content}>
                  <Image
                    className={styles.icon}
                    placeholderSrc={urlFor(item.comparisonIcon).width(20).url()}
                    sources={[urlFor(item.comparisonIcon).width(160).url()]}
                    height={['2rem', '2.25rem', '2.5rem', '3rem']}
                    width={['2rem', '2.25rem', '2.5rem', '3rem']}
                    alt=""
                  />
                  <div className={styles.contentWrap}>
                    <Heading variant="h5" as="h3">
                      {item.comparisonTitle}
                    </Heading>
                  </div>
                </div>
                <Text variant="bodyRegular" className={styles.contentText}>
                  {item.comparisonText}
                </Text>
              </SmallContainer>
            </FadeInChild>
          )
        })}
      </div>
      <SectionBottomLine />
    </section>
  )
}
